import axios from "axios";
import { takeLatest, call, put } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const UPDATE_PROGRESS = "saga/UPDATE_PROGRESS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA_FAILURE = "saga/FETCH_TABLE_DATA_FAILURE";

export const actionCreators = {
  setLoading: createAction(SET_LOADING),
  updateProgress: createAction(UPDATE_PROGRESS),
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchTableData: createAction(FETCH_TABLE_DATA),
  fetchTableDataSuccess: createAction(FETCH_TABLE_DATA_SUCCESS)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, getTableData);
}

export function* getCurrentUserData(data) {
  try {
    // Get user data first. Once we confirm we have user data pass to other sagas and call them.
    yield put({ type: SET_LOADING, payload: true });
    // const response = yield call(axios.get, queryParams.apiVersion + '/base/get_params?noCache=' + Math.random())
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

    let date = data.payload.date;
    let y;
    let m;
    let d;

    if (!date) {
      let newdate = new Date();
      m = newdate.getMonth() + 1;
      y = newdate.getFullYear();
      d = newdate.getDate();
      date = y + "-" + m + "-" + d;
    }

    let params = {
      organizationId: data.payload.organizationId,
      organizationName: data.payload.organizationName,
      objectId: data.payload.objectId,
      locationId: data.payload.locationId,

      showViewAllDataButton: data.payload.showViewAllDataButton,
      showViewAllDataUrl: data.payload.showViewAllDataUrl,

      showSharedMembersDataButton: data.payload.showSharedMembersDataButton,
      showSharedMembersUrl: data.payload.showSharedMembersUrl,
      hideSharedMembersDataButton: data.payload.hideSharedMembersDataButton,
      hideSharedMembersUrl: data.payload.hideSharedMembersUrl,

      date: date,
      start_date: data.payload.start_date,
      end_date: data.payload.end_date,

      filters: JSON.parse(data.payload.filters),

      shift_months: data.payload.shift_months,
      period: data.payload.period,
      period_days: data.payload.period_days,
      period_type: data.payload.period_type || "monthly",

      year: data.payload.year || y,
      month: data.payload.month || m,
      day: data.payload.day || d,

      chart_name: data.payload.chart_name,
      category_type: data.payload.category_type,
      category_type_id: data.payload.category_type_id,

      data_url: data.payload.data_url,

      exclude_offers: data.payload.exclude_offers,
      exclude_intros: data.payload.exclude_intros,
      include_returns: data.payload.include_returns
    };

    const getTableDataSaga = getTableData(params);

    yield getTableDataSaga;
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CURRENT_USER_FAILURE, error });
  }
}

export function* getTableData(params) {
  try {
    var tableDataResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        params.data_url +
        "?organization_id=" +
        params.organizationId +
        "?organization_name=" +
        params.organizationName +
        "&location_id=" +
        params.locationId +
        "&object_id=" +
        params.objectId +
        "&date=" +
        params.date +
        "&start_date=" +
        params.start_date +
        "&end_date=" +
        params.end_date +
        "&year=" +
        params.year +
        "&month=" +
        params.month +
        "&day=" +
        params.day +
        "&shift_months=" +
        params.shift_months +
        "&period=" +
        params.period +
        "&period_days=" +
        params.period_days +
        "&period_type=" +
        params.period_type +
        "&" +
        jQuery.param({ filters: params.filters }) +
        "&chart_name=" +
        params.chart_name +
        "&category_type=" +
        params.category_type +
        "&category_type_id=" +
        params.category_type_id +
        "&exclude_offers=" +
        params.exclude_offers +
        "&exclude_intros=" +
        params.exclude_intros +
        "&include_returns=" +
        params.include_returns +
        "&limit=100"
    );

    tableDataResponse.data.showViewAllDataButton = params.showViewAllDataButton;
    tableDataResponse.data.showViewAllDataUrl = params.showViewAllDataUrl;

    tableDataResponse.data.showSharedMembersDataButton = params.showSharedMembersDataButton;
    tableDataResponse.data.showSharedMembersUrl = params.showSharedMembersUrl;
    tableDataResponse.data.hideSharedMembersDataButton = params.hideSharedMembersDataButton;
    tableDataResponse.data.hideSharedMembersUrl = params.hideSharedMembersUrl;

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: tableDataResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TABLE_DATA_SUCCESS, error });
  }
}
